import { UPDATE_FIELD_SUCCESS } from 'actions';
import { FieldType } from 'enums';
import { Model, ModelType, attr } from 'redux-orm';

export interface IFieldValue {
  key: string;
  displayValue?: string;
  isVisible?: boolean;
}

export interface IField {
  key: string;
  createdBy: 'USER' | 'SYSTEM';
  description: string;
  displayValue: string;
  isEditable: boolean;
  isVisible: boolean;
  maxItems: number | null | boolean;
  multiline: boolean;
  placeholderValue: string;
  relatedEntity: 'COMPANY' | 'CONTACT';
  type: FieldType;
  values?: IFieldValue[] | null;
}

interface Action {
  type: string;
  data: IField;
}

class Field extends Model<typeof Field, IField> {
  id!: string;

  key!: string;

  createdBy!: 'USER' | 'SYSTEM';

  description!: string;

  displayValue!: string;

  isEditable!: boolean;

  isVisible!: boolean;

  maxItems!: number;

  multiline!: boolean;

  placeholderValue!: string;

  relatedEntity!: 'COMPANY' | 'CONTACT';

  type!: FieldType;

  values?: IFieldValue[] | null;

  static reducer(action: Action, model: ModelType<Field>) {
    // eslint-disable-next-line default-case
    switch (action.type) {
      case UPDATE_FIELD_SUCCESS:
        // @ts-ignore - idAttribute is key
        model.upsert(action.data);
        break;
    }

    return undefined;
  }

  toViewModel() {
    return {
      id: this.key,
      ...this.ref,
    };
  }
}

Field.modelName = 'Field';

Field.fields = {
  key: attr(),
  createdBy: attr(),
  displayValue: attr(),
  isEditable: attr(),
  isVisible: attr(),
  maxItems: attr(),
  multiline: attr(),
  relatedEntity: attr(),
  type: attr(),
  values: attr(),
};

Field.options = {
  idAttribute: 'key',
};

export type FieldViewModel = ReturnType<Field['toViewModel']>;

export default Field;
